import { uploadFile } from "@/api/common";

const uploadFiles = {
  data() {
    return {
      files: [],
      resFiles: [],
    };
  },
  methods: {
    addDropFile(e) {
      this.files = Array.from(e.dataTransfer.files);
      this.changeFiles(this.files);
    },
    changeFiles(files) {
      files.forEach(async (file, i) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("seq", i);
        formData.append("fileLoc", 1);
        formData.append("idNo", 1);

        try {
          // formData send
          const { data } = await uploadFile(formData);
          this.resFiles.push(data.fileNo);
        } catch (error) {
          console.error(error.response.data.message);
        }
      });
    },
  },
};

export default uploadFiles;
